import React from 'react';

import { ChevronDownIcon } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, Button, Separator, Badge } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import PageVariablesModal from 'components/modals/PageVariablesModal';

const modalBottom = () => <div>
  <h3>Page Logic (advanced)</h3>
  <p>
    <a href="http://handlebarsjs.com/" target="_blank" rel="noopener noreferrer">Handlebars templates</a> are fully supported in the content of pages. Variables made
    available for use in Handlebars are as follows:
  </p>
  <ul>
    <li><strong>isMobile</strong>: Boolean value to indicate whether the request appears to be a mobile device.</li>
  </ul>
  <p>
    If you need additional variables, please contact us.
  </p>
</div>

export default function PageHeading({ data: page, children: options, active, onChangeActive, disabled = false }) {
  return <>
    <HeaderContainerForm
      title='Pages'
      data={{ ...page, createdAt: formatDateTime(page?.created_at), updatedAt: formatDateTime(page?.updated_at) }}
      onCancel={() => history.goBack()}
      extraTitle={page?.type ? <Badge variant='outline' size='lg' className='self-center'>{page.type}</Badge> : null}
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} disabled={disabled} />
      <Separator orientation='vertical' className='py-5' />
      <DropdownMenu optionsLabel='Options'>
        <DropdownMenuTrigger className='flex items-center gap-1'>
          <Button size='lg' variant='outline'>
            Quick Actions
            <ChevronDownIcon size={16} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start' forceMount>
          <PageVariablesModal bottom={modalBottom()} />
          {options}
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainerForm>
  </>
}
